// extracted by mini-css-extract-plugin
export default {"Notification":"Notification_Notification__0A5Pb","Container":"Notification_Container__C78tx","ButtonsWrap":"Notification_ButtonsWrap__YgPwN"};